import axios from "axios";
import { event } from "../index";
import md5 from "md5";
import { Modal, message } from "antd";
import { set_env, env, env_code, env_resource } from "@dt/util";
import { UserChannel } from "./channel";
const { apiHost } = env;
/**
 yyyy-MM-dd : 年月日
 yyyy-MM-dd hh:mm:ss 年月日 时分秒
 **/
Date.prototype.format = function (fmt) {
    //author: meizz
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds(), //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return fmt;
};

var lib = {
    config: {
        webToken: "admin",
        env: "online",
        hostLogin: "integration.yang800.com.cn",
        // openByWindow:false,
        // pageTitleCanEmpty:false
        loadUrlList: [], // 加载load
    },
    throttle(fn, delay) {
        var timer;
        return function () {
            var _this = this;
            var args = arguments;
            if (timer) {
                return;
            }
            timer = setTimeout(function () {
                fn.apply(_this, args);
                timer = null; // 在delay后执行完fn之后清空timer，此时timer为假，throttle触发可以进入计时器
            }, delay);
        };
    },
    debounce(fn, delay) {
        var timer; // 维护一个 timer
        return function () {
            var _this = this; // 取debounce执行作用域的this
            var args = arguments;
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(function () {
                fn.apply(_this, args); // 用apply指向调用debounce的对象，相当于_this.fn(args);
            }, delay);
        };
    },
    /**
     *
     * @param url /test-detail?pageTitle=测试详情页
     * @param element 字符串或者任何html无素如div button等
     * @param refreshFn 回调函数，作状态更新使用
     */
    getLink() {
        console.error(new Error("function lib.getLink has been delete please use lib.openPage for replace"));
    },

    getOtherSystemPage(url, systemCode) {
        let systemPath = env_resource[env_code.platformCode]?.[systemCode]?.systemPath;
        let host = location.host;
        let devHost = lib.getDevHost();
        if (devHost) {
            host = devHost;
        }
        return `//${host}/${systemPath}${url}`;
    },
    getDevHost() {
        let localLoginMap = {
            integration: "integration.yang800.com.cn",
            dev: "dev.yang800.com.cn",
            test: "test.yang800.com.cn",
            pre: "pre.yang800.com",
        };
        let host;
        if (["127.0.0.1", "localhost"].includes(location.hostname)) {
            host = localLoginMap[lib.config.env] || lib.config.hostLogin;
        }
        return host;
    },
    /**
     * 打开一个新页面
     * @param url
     * @param params 页面传参
     * @param refreshFn 刷新函数
     * @param openByWindow 打开页面通过Window.location
     * @param pageTitleCanEmpty  pageTitle是否能为空
     */
    openPageV2({ url, params, refreshFn, openByWindow = false, pageTitleCanEmpty = false }) {
        this.openPage(url, refreshFn, openByWindow, pageTitleCanEmpty, params);
    },
    /**
     *
     * @param url /test-detail?pageTitle=测试详情页
     * @param refreshFn 回调函数，作状态更新使用
     * @param openByWindow   window.location 打开页面
     * @param pageTitleCanEmpty   window.location 打开页面
     */
    openPage(url, refreshFn, openByWindow = false, pageTitleCanEmpty = false, params = {}) {
        // let refreshEvent = md5(window.location.href);
        if (!url) {
            return console.error("function openPage must have a url");
        }
        url = url.replace("pageTitle", "page_title");
        let refreshEvent = md5(url);
        // 区分pageTitleCanEmpty 优先级
        let TitleCanEmpty = false;
        if (pageTitleCanEmpty) {
            TitleCanEmpty = true;
        } else {
            if (this.config.hasOwnProperty("pageTitleCanEmpty")) {
                TitleCanEmpty = this.config.pageTitleCanEmpty;
            }
        }
        if (!TitleCanEmpty && (url.indexOf("?") === -1 || url.indexOf("page_title") === -1)) {
            return console.error("function openPage url must have a page_title or pageTitle value");
        }
        if (refreshFn) {
            url += `&refresh_event=${refreshEvent}`;
            event.on(refreshEvent, refreshFn, location.href);
        }
        let { systemPath } = env;
        if (!systemPath) {
            console.warn("openPage,systemPath is empty");
        }
        const path = url.split("/");
        let urlSystemPath;
        if (url.indexOf("/") === 0) {
            //以 "/" 开头
            urlSystemPath = path[1];
        } else {
            if (path.length > 1) {
                urlSystemPath = path[0];
            } else {
                urlSystemPath = "";
            }
        }
        if (systemPath && urlSystemPath !== systemPath) {
            url = `/${systemPath}${url}`;
        }
        // openByWindow 优先级
        let openMethods = false;
        if (openByWindow) {
            openMethods = true;
        } else {
            if (this.config.hasOwnProperty("openByWindow")) {
                openMethods = this.config.openByWindow;
            }
        }
        if (openMethods) {
            window.location.href = url;
        } else {
            event.emit("add-page", {
                url: url,
                params: params,
                refreshFn,
                refreshEvent,
                sourceUrl: window.location.href,
            });
        }
    },

    /**
     * 关闭当前页面
     */
    closePage(url) {
        event.emit("delete-page", { url });
    },

    getParam(key, url) {
        var strs = (url || window.location.href).split("?")[1];
        if (!strs) {
            return null;
        }
        var json = {};
        var b = strs.split("&");
        for (var i = 0; i < b.length; i++) {
            var [_key, _value] = b[i].split("=");
            json[_key] = _value;
        }
        if (key == undefined) {
            return json;
        }
        if (json[key] == undefined) {
            return null;
        }
        return decodeURIComponent(json[key]);
    },

    /**
     字段名             类型       是否必填      说明
     url               string      是         访问的URL
     data              json        否         请求的数据
     success           function    是         请求成功回调函数
     fail              function    否         失败回调函数
     needMask          boolean     否         是否需要遮照，默认为true
     **/
    request(
        {
            url,
            needMask = false,
            data,
            success = function (data) {},
            fail = function (code, msg, data) {}, // code：状态码  msg:提示信息  data: json字符串
            config,
        },
        showErrorMessage = true, // 是否显示错误信息，默认为true, 想自行处理时请设置为false
    ) {
        let prefixUrl = apiHost;
        let [clientId, clientSecret] = ["9E514E70AD7D485986D687F64616C662", "33F14542BB274284B63147E6C8F3DF9E"];
        if (["integration", "dev", "test", "pre"].includes(lib.config?.env)) {
            clientId = "96A63530DA0C49BB9FABB66ED40FB3C7";
            clientSecret = "F6A99B36E4D24817AB037237454893D9";
            let gatewayMap = {
                integration: `https://danding-gateway-integration.yang800.com.cn`,
                dev: `https://danding-gateway-dev.yang800.com.cn`,
                test: `https://danding-gateway-test.yang800.com.cn`,
                pre: `https://danding-gateway-pre.yang800.com`,
            };
            prefixUrl = gatewayMap[lib.config.env] || lib.config.env;
        } else {
            let gatewayMap = {
                "www.yang800.com": "https://danding-gateway.yang800.com",
                "yccp.yang800.com": "https://danding-gateway.yang800.com",
                "www.dataeta.com": "https://danding-gateway.dataeta.com",
                "www.yangmaigu.com": "https://danding-gateway.yangmaigu.com",
                "jieztech.com": "https://soul-gateway.jieztech.com",
            };
            const hostname = location.hostname;
            if (gatewayMap[hostname]) {
                prefixUrl = gatewayMap[hostname];
            } else {
                const regex = /([a-zA-Z0-9-]+\.[a-zA-Z]{2,})$/;
                const match = hostname.match(regex);
                const rootHost = match ? match[0] : hostname;
                prefixUrl = `https://gateway.${rootHost}`;
            }
        }

        if (lib.config.env === "jz") {
            clientId = "9E514E70AD7D485986D687F64616C662";
            clientSecret = "33F14542BB274284B63147E6C8F3DF9E";
        }
        let timestamp = new Date().getTime();
        let md5Data = "";
        if (data && JSON.stringify(data) != "{}") {
            md5Data = md5(JSON.stringify(data)).toUpperCase();
        }
        let sign = md5(
            `clientId${clientId}data${md5Data}path${url}timestamp${timestamp}version${"1.0.0"}${clientSecret}`,
        ).toUpperCase();
        needMask && lib.wait();
        let maskTime = new Date().getTime();
        if (url.indexOf("http://") == -1 && url.indexOf("https://") == -1 && !url.includes("yapi")) {
            url = `${prefixUrl}${url}`;
        } else {
        }

        if (needMask) {
            if (this.config.loadUrlList.length === 0) {
                lib.wait();
            }
            // 对重复请求做数量累加
            if (this.config.loadUrlList.filter(item => item.url === url).length > 0) {
                for (let i = 0; i < this.config.loadUrlList.length; i++) {
                    const item = this.config.loadUrlList;
                    if (item.url === url) {
                        item.count += 1;
                    }
                }
            } else {
                this.config.loadUrlList.push({ url: url, count: 1 });
            }
        }
        return axios
            .request({
                url: url,
                method: "POST",
                data: data,
                headers: {
                    timestamp: timestamp,
                    clientId: clientId,
                    sign: sign,
                    webToken: this.config.webToken,
                    ...(config && config?.header),
                },
                withCredentials: true,
                crossDomain: true,
            })
            .then(({ data: json }) => {
                let { code, data, message: msg } = json;
                if (code == 200) {
                    success(data, msg);
                    return data;
                }
                ErrorTreatFn(code, data, msg, fail, showErrorMessage, url);
            })
            .catch(e => {
                if (url.indexOf("/ucenter-account/current/message/listener") > -1) {
                    //针对公告轮询做不报错处理 业务需求
                    return;
                }
                message.error("服务器异常");
                // 统一处理e成json字符串
                const errorJsonStr = JSON.stringify(e);
                fail && fail(500, "服务器异常", errorJsonStr);
                throw e;
            })
            .finally(e => {
                if (!needMask) return;
                let index = -1;
                for (let i = 0; i < this.config.loadUrlList.length; i++) {
                    const item = this.config.loadUrlList[i];
                    if (item.url === url) {
                        item.count--;
                        if (item.count === 0) index = i;
                    }
                }
                // 如果有一项的数量为零，删除这一项
                if (index >= 0) this.config.loadUrlList.splice(index, 1);
                if (this.config.loadUrlList.length === 0) {
                    setTimeout(() => {
                        lib.waitEnd();
                    }, 500 - new Date().getTime() + maskTime);
                }
            });
    },
    getAxios() {
        return axios;
    },
    wait(time) {
        var div = document.getElementById("react-single-app-wait");
        if (!div) {
            div = document.createElement("div");
            div.id = "react-single-app-wait";
            div.innerHTML = `
                <div class='mask' style="display:flex;justify-content:center;align-items: center;background: rgba(256,256,256,0.5);opacity: 1;">
                    <div class="ant-spin ant-spin-lg ant-spin-spinning center">
                        <span class="ant-spin-dot ant-spin-dot-spin">
                            <i class="ant-spin-dot-item"></i>
                            <i class="ant-spin-dot-item"></i>
                            <i class="ant-spin-dot-item"></i>
                            <i class="ant-spin-dot-item"></i>
                        </span>
                        <div>正在处理中，请稍等</>
                    </div>
                </div>
            `;
            document.body.append(div);
        }
        if (time) {
            setTimeout(lib.waitEnd, time);
        }
    },
    waitEnd() {
        if (document.getElementById("react-single-app-wait")) {
            document.getElementById("react-single-app-wait").remove();
        }
    },
    setConfig(config, envConfig) {
        Object.assign(this.config, config);
        if (!envConfig) {
            console.error("envConfig must set‼️");
            return;
        }
        set_env(envConfig);
        this.parseUserAgent();
    },
    parseUserAgent() {
        const userAgent = navigator.userAgent.toLowerCase();
        window.isWxwork = /wxwork/i.test(userAgent); //企业微信
    },
    isType(obj, type) {
        if (typeof obj !== "object") return false;
        const typeString = Object.prototype.toString.call(obj);
        let flag;
        switch (type) {
            case "Array":
                flag = typeString === "[object Array]";
                break;
            case "Date":
                flag = typeString === "[object Date]";
                break;
            case "RegExp":
                flag = typeString === "[object RegExp]";
                break;
            default:
                flag = false;
        }
        return flag;
    },
    /**
     * deep clone
     * @param  {[type]} parent object 需要进行克隆的对象
     * @return {[type]}        深克隆后的对象
     */
    clone(parent) {
        // 维护两个储存循环引用的数组
        const parents = [];
        const children = [];

        const _clone = parent => {
            if (parent === null) return null;
            if (typeof parent !== "object") return parent;

            let child, proto;

            if (this.isType(parent, "Array")) {
                // 对数组做特殊处理
                child = [];
            } else if (this.isType(parent, "RegExp")) {
                // 对正则对象做特殊处理
                child = new RegExp(parent.source);
                if (parent.lastIndex) child.lastIndex = parent.lastIndex;
            } else if (this.isType(parent, "Date")) {
                // 对Date对象做特殊处理
                child = new Date(parent.getTime());
            } else {
                // 处理对象原型
                proto = Object.getPrototypeOf(parent);
                // 利用Object.create切断原型链
                child = Object.create(proto);
            }

            // 处理循环引用
            const index = parents.indexOf(parent);

            if (index != -1) {
                // 如果父数组存在本对象,说明之前已经被引用过,直接返回此对象
                return children[index];
            }
            parents.push(parent);
            children.push(child);

            for (let i in parent) {
                // 递归
                child[i] = _clone(parent[i]);
            }

            return child;
        };
        return _clone(parent);
    },
    setCookie: function (key, val, time = 1) {
        //设置cookie方法
        var date = new Date(); //获取当前时间
        var expiresDays = time; //将date设置为n天以后的时间
        date.setTime(date.getTime() + expiresDays * 24 * 3600 * 1000); //格式化为cookie识别的时间
        document.cookie = key + "=" + val + ";expires=" + date.toString(); //设置cookie
    },
    getCookie: function (key) {
        //获取cookie方法
        /*获取cookie参数*/
        var getCookie = document.cookie.replace(/[ ]/g, ""); //获取cookie，并且将获得的cookie格式化，去掉空格字符
        var arrCookie = getCookie.split(";"); //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
        var tips; //声明变量tips
        for (var i = 0; i < arrCookie.length; i++) {
            //使用for循环查找cookie中的tips变量
            var arr = arrCookie[i].split("="); //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
            if (key == arr[0]) {
                //匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
                tips = arr[1]; //将cookie的值赋给变量tips
                break; //终止for循环遍历
            }
        }
        return tips;
    },
    localDevelopDebug() {
        const host = this.getDevHost();
        if (location.host.includes("127.0.0.1") || location.host.includes("localhost")) {
            if (!document.getElementById("login-iframe")) {
                const iframe = document.createElement("iframe");
                iframe.src = `https://${host}/${lib.config.webToken === "admin" ? "login-admin" : "login"}/login`;
                iframe.width = "100%";
                iframe.id = "login-iframe";
                iframe.height = "100%";
                iframe.allowFullscreen = true;
                const div = document.createElement("div");
                div.className = "iframe-container";
                div.appendChild(iframe);
                document.body.appendChild(div);
                window.addEventListener("message", e => {
                    if (e.origin.includes(host)) {
                        lib.setCookie("token", e.data);
                        window.location.reload();
                    }
                });
            }
        }
    },
    setSession(key, value) {
        // 存储数据
        sessionStorage.setItem(key, JSON.stringify(value));
    },
    getSession(key) {
        // 获取数据
        const value = sessionStorage.getItem(key);
        return value ? JSON.parse(value) : null;
    },
    removeSession(key) {
        // 删除数据
        sessionStorage.removeItem(key);
    },
    clear() {
        // 清空所有数据
        sessionStorage.clear();
    },
    broadcastPostMessage() {
        // 获取监听消息
        UserChannel.onmessage = event => {
            const { type, data } = event.data;
            const { userName, masterUserName, userId, masterUserId, role } = data;
            // 获取用户信息
            let userData = lib.getSession("userData");

            console.log("env", env, data, userData);
            /** 商家端不能互通，小二和商家可以同时登录一个账号 */
            const { isAdmin, isWMS, isUser } = env;
            let isUserRole = (isWMS || isUser) && ["wms", "user"].includes(role);

            // 切换登录用户
            if (
                type === "usernameChange" &&
                userId != userData.userId &&
                (isUserRole || (isAdmin && role === "admin"))
            ) {
                lib.showConfirm(`登录用户已经更换为${userName},需刷新页面才可以获得最新数据`);
            }

            /**
             * isUserRole 判断：登录身份为商家（当前小二端没有切仓）
             *
             * type === "warehouseChange" 判断：一个或多个已登录页面，其中一个页面切换仓库，弹窗提醒其他页面刷新
             *
             * type === "usernameChange" && userId == userData.userId 判断：页面登录为同账号，其中一个切换了仓库，另一个页面退出登录且重新登录，判断主账号是否相同
             */
            if (
                isUserRole &&
                masterUserId != userData.masterUserInfo.userId &&
                (type === "warehouseChange" || (type === "usernameChange" && userId == userData.userId))
            ) {
                lib.showConfirm(`主账号已切换为${masterUserName},需刷新页面才可以获得最新数据`);
            }
        };
        UserChannel.addEventListener("message", onmessage);
        return () => {
            // 组件卸载时关闭BroadcastChannel
            UserChannel.removeEventListener("message", onmessage);
        };
    },
    showConfirm(content) {
        if (Modal.confirm.modal) {
            Modal.destroyAll();
        }
        Modal.confirm({
            title: "确认对话框",
            content,
            keyboard: false,
            cancelButtonProps: { style: { display: "none" } },
            onOk: () => {
                window.location.reload();
            },
            afterClose: () => {
                // 清除全局变量中的弹窗引用
                Modal.confirm.modal = null;
            },
        });
        // 将全局变量设置为true，表示存在弹窗
        Modal.confirm.modal = true;
    },
};

// 错误处理
const ErrorTreatFn = (code, data, msg, fail, showErrorMessage, url) => {
    let { systemPath } = env;
    let loginSystemPath = lib.config.webToken === "admin" ? "login-admin" : "login";
    let loginHost = location.host;
    let localLoginMap = {
        integration: "integration.yang800.com.cn",
        dev: "dev.yang800.com.cn",
        test: "test.yang800.com.cn",
        pre: "pre.yang800.com",
    };
    let redirectUrl = `redirectUrl=${encodeURIComponent(window.location.href)}`;
    if (["127.0.0.1", "localhost"].includes(location.hostname)) {
        loginHost = localLoginMap[lib.config.env] || lib.config.hostLogin;
    }
    let loginRole = lib.config.webToken; // 登录页面角色 小二 admin、商家 user、仓库人员 wms
    if ("DT_WMS" === lib.config.systemCode) {
        loginRole = "wms";
    }
    if (code === -1001) {
        //登录页的请求不要在跳转到登录页，提示错误
        if (["/login-admin/login", "login/login"].includes(location.pathname)) {
            message.error(msg);
            return;
        }
        //查询租户个性化设置接口不需要登录鉴权
        if (["/ucenter-config/personal/query"].some(item => url.includes(item))) {
            return;
        }
        // 本地debug跳转禁用
        if (location.host.includes("127.0.0.1") || location.host.includes("localhost")) return;
        //针对公告轮询做不报错处理 业务需求(后台部分环境未去除登录态教研)
        if (url.indexOf("/ucenter-account/current/message/listener") > -1) return;
        // 未登录
        window.location = `//${loginHost}/${loginSystemPath}/login?${redirectUrl}&loginRole=${loginRole}`;
    } else if (code === -1002 && location.pathname !== "/not-permission") {
        // 没有权限
        window.location = `${location.origin}/${systemPath}/not-permission?page_title=未授权`;
    } else if (code === -1003) {
        // 单点登录
        message.error(msg);
        setTimeout(() => {
            window.location = `//${loginHost}/${loginSystemPath}/login?${redirectUrl}&loginRole=${loginRole}`;
        }, 3000);
    } else if (code > -2999 && code < -2000) {
        // 网关错误
        message.error(msg);
    } else {
        if (url.indexOf("/ucenter-account/current/message/listener") > -1) {
            //针对公告轮询做不报错处理 业务需求
            return;
        }
        showErrorMessage && code < 0 && message.error(msg);
        fail && fail(code, msg, data);
    }
};

if (!window.__lib__) {
    window.__lib__ = lib;
}

export default window.__lib__;
